import {Button, Card, CardActions, CardContent, colors, Grid, Modal, Theme, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import {useSnackbar} from 'notistack';
import React from 'react';
import {LoadingOverlay} from '../../../components/LoadingOverlay';
import {getMe} from '../../../graphql/auth';
import anyLoading from '../../../utils/anyLoading';
import sendVerifyEmail from '../sendVerifyEmail.api';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        outline: 'none',
        boxShadow: theme.shadows[20],
        width: 700,
        maxHeight: '90%',
        overflowY: 'auto',
        maxWidth: '95%'
    },
    container: {
        marginTop: theme.spacing(3)
    },
    actions: {
        justifyContent: 'flex-end'
    },
    saveButton: {
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        '&:hover': {
            backgroundColor: colors.green[900]
        }
    }
}));

const ResendVerifyEmailModal = (props: {
    className?: string,
    onClose?: () => void,
    onLogout?: () => void,
    open: boolean,
}) => {
    const {open, onClose, className, onLogout, ...rest} = props;
    const classes = useStyles();
    const meData = getMe();
    const [callSendVerifyEmail, sendVerifyEmailData] = sendVerifyEmail();
    const loadingData = anyLoading(meData, sendVerifyEmailData);
    const {enqueueSnackbar} = useSnackbar();

    if (!open) {
        return null;
    }

    const user = meData.data && meData.data.me;

    const onSendClick = () => {
        if (user) {
            callSendVerifyEmail({variables: {id: user.id}})
                .then(() => {
                    enqueueSnackbar('Email Sent', {variant: 'success'});
                    meData.refetch();
                    if (onClose) onClose();
                })
                .catch(() => {
                    enqueueSnackbar('Send Email Failed.', {variant: 'error'});
                    if (onClose) onClose();
                });
        }
    };

    return (
        <Modal onClose={onClose} open={open}>
            <Card {...rest} className={clsx(classes.root, className)}>
                <LoadingOverlay loading={loadingData.loading}>
                    <form>
                        <CardContent>
                            <Typography gutterBottom variant="h3">
                                Verify Email Address
                            </Typography>
                            <Grid className={classes.container} container spacing={3}>
                                <Grid item xs={12}>
                                    <Typography variant={'body1'}>
                                        Your email address '{user && user.email}' has not been verified. If you would
                                        like us to send you another verification email please click the button below.
                                    </Typography>
                                </Grid>
                            </Grid>
                        </CardContent>
                        <CardActions className={classes.actions}>
                            {onClose && (<Button onClick={onClose} variant="contained">Close</Button>)}
                            {onLogout && (<Button onClick={onLogout} variant="contained">Log Out</Button>)}
                            <Button className={classes.saveButton} onClick={onSendClick}
                                    variant="contained">Send</Button>
                        </CardActions>
                    </form>
                </LoadingOverlay>
            </Card>
        </Modal>
    );
};

export default ResendVerifyEmailModal;
